import React from 'react';
import { can } from '../../access';
import './RequireAccess.scss';
import { canOpenRoute, canOpenTeamMember } from '../../route-access';

const NotAuthorized = () => (
    <div className='NotAuthorized'>
        <h1>Not Authorized</h1>
        <p>Additional account permissions needed to view this page.</p>
    </div>
);

/**
 * A route guard decided by the signed-in member's permissions.
 *
 * What Root gave it (userData and access) is handed on. The router's own
 * props are not: this route is pathless, so its routeParams and route would
 * replace the page's own (AgentCommissionDetails reads routeParams).
 */
export const requireAccess = (isAllowed) => {
    const Guard = (props) => {
        const { children, route, routes, routeParams, params, location, router, ...passThrough } = props;
        return isAllowed(props)
            ? React.cloneElement(children, passThrough)
            : <NotAuthorized/>;
    };
    return Guard;
};

const guards = {};

/**
 * The pathless guard for a route in routes.js, by its path as written there
 * (route-access.js). One component per path, so React keeps the page mounted
 * across re-renders.
 */
export const routeGuard = (path) => {
    if (!guards[path]) guards[path] = requireAccess(() => canOpenRoute(can, path));
    return guards[path];
};

/** The index route cannot sit under a pathless guard: wrap the page itself. */
export const guardedPage = (path, Page) => (props) => (canOpenRoute(can, path) ? <Page {...props}/> : <NotAuthorized/>);

/** A team member's page: anyone with the team list, and everyone for their own record (it is where their Forms are). */
export const TeamMemberPageAccess = requireAccess((props) =>
    canOpenTeamMember(can, props.params && props.params.id, props.userData && props.userData.id));
